import { setupWorker } from 'msw'
import handler from './handler'

const msw = setupWorker(...handler)

export default msw
